import { type ComponentProps, mergeProps, Show } from "solid-js";
import Text from "../../text/Text";
import { useTranslation } from "../../../state/i18n";
import { Icon } from "../../icon/Icon";
import TextSelectValue from "../selectValues/TextSelectValue";
import type { TextOption } from "../../../types/Menu";

type CompactSingleSelectTriggerProps = {
  ariaLabel: string;
  label: Pick<TextOption<null>, "label">["label"] | undefined;
  placeholder?: string;
  disabled?: boolean;
  arkProps: ComponentProps<"button">;
};

const CompactSingleSelectTrigger = (rawProps: CompactSingleSelectTriggerProps) => {
  const props = mergeProps({ disabled: false }, rawProps);

  let triggerRef: HTMLButtonElement | undefined;
  const { t } = useTranslation();

  return (
    <button
      ref={triggerRef}
      aria-label={props.ariaLabel}
      disabled={props.disabled}
      class="group flex h-7 max-w-full items-center rounded-sm border py-1 pr-1 pl-2 text-start focus-visible:outline-default"
      classList={{
        "border-disabled bg-surface-disabled text-disabled": props.disabled,
        "cursor-pointer border-default bg-surface-default hover:bg-surface-hover": !props.disabled,
      }}
      {...props.arkProps}
    >
      <div class="flex w-full min-w-0">
        <Show
          when={props.label}
          fallback={
            <Text
              as="span"
              truncate
              text={props.placeholder ?? t(($) => $.SELECT_INPUT_PLACEHOLDER_DEFAULT)}
              class="text-base-medium text-placeholder select-none"
            />
          }
        >
          {(label) => <TextSelectValue label={label()} />}
        </Show>
      </div>
      <div class="flex size-7 items-center justify-center">
        <Icon
          type="solid"
          name="chevronDown"
          size="md"
          class="shrink-0"
          classList={{ "icon-disabled": props.disabled, "icon-secondary": !props.disabled }}
        />
      </div>
    </button>
  );
};

export default CompactSingleSelectTrigger;
